import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import '../css/Applications.css';

const Applications = () => {
  const [groupedApplications, setGroupedApplications] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const res = await axios.get('/api/applications');
        const apps = res.data || [];

        const grouped = {};
        apps.forEach((app) => {
          const programName = app.programId?.program || 'Unknown Program';
          if (!grouped[programName]) grouped[programName] = [];
          grouped[programName].push(app);
        });

        setGroupedApplications(grouped);
      } catch (err) {
        console.error('Failed to fetch applications:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchApplications();
  }, []);

  if (loading) {
    return (
      <Box className="apps-loader-wrapper">
        <CircularProgress />
      </Box>
    );
  }

  const hasApps = Object.keys(groupedApplications).length > 0;

  return (
    <Box p={3}>
      <div className="apps-content-card">
        <div className="apps-card-header">
          <div>
            <h3 className="apps-card-title">Application Lists</h3>
            <p className="apps-card-subtitle">
              Review student applications grouped by KSE program.
            </p>
          </div>
          {/* Example secondary action, keep if you later add a route */}
          {/* <button
            className="apps-secondary-btn"
            onClick={() => navigate('/dashboard/programs')}
          >
            Manage Programs
          </button> */}
        </div>

        {!hasApps ? (
          <div className="apps-empty-state">
            <h4 className="apps-empty-title">No applications yet</h4>
            <p className="apps-empty-text">
              Once students start applying to programs, you will see them listed here by program.
            </p>
          </div>
        ) : (
          <div className="apps-program-grid">
            {Object.entries(groupedApplications).map(([programName, apps]) => (
              <div key={programName} className="apps-program-card">
                <div className="apps-program-header">
                  <h3 className="apps-program-title">KSE Program: {programName}</h3>
                  <span className="apps-program-count">
                    {apps.length} applicant{apps.length !== 1 ? 's' : ''}
                  </span>
                </div>

                <ul className="apps-applicant-list">
                  {apps.map((app) => (
                    <li key={app._id} className="apps-applicant-item">
                      <div className="apps-applicant-main">
                        <p className="apps-applicant-name">{app.name}</p>
                        <p className="apps-applicant-std">Std: {app.std}</p>
                      </div>
                      <div className="apps-applicant-meta">
                        <p className="apps-job-details">
                          <strong>School:</strong> {app.school}
                        </p>
                        <p className="apps-job-details">
                          <strong>Contact:</strong> {app.contact}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    </Box>
  );
};

export default Applications;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Box,  CircularProgress } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import '../css/Applications.css';

// const Applications = () => {
 
//     const [groupedApplications, setGroupedApplications] = useState({});
//       const [loading, setLoading] = useState(true);
//       const navigate = useNavigate();
     
//       useEffect(() => {
//     const fetchApplications = async () => {
//       try {
//         const res = await axios.get('/api/applications');
//         const apps = res.data;

       
//         const grouped = {};
//         apps.forEach((app) => {
//           const programName = app.programId?.program || "Unknown Program";
//           console.log('program name', programName);
//           if (!grouped[programName]) {
//             grouped[programName] = [];
//           }
//           grouped[programName].push(app);
//         });

//         setGroupedApplications(grouped);
//       } catch (err) {
//         console.error("Failed to fetch applications:", err);
//       }
//     };

//     fetchApplications();
//   }, []);
    
      
    

//     return (
//     <Box p={3}>
//      <div className='contentCard'>
//             <div className='cardHeader'>
//               <h3 className='cardTitle'>Application Lists</h3>
             
//             </div>
//            {Object.entries(groupedApplications).map(([programName, apps]) => (
//               <div key={programName} className='jobCard'>
//                 <div className='jobInfo'>
//                   <h3> KSE Program: {programName}</h3>
                  
//                    <ul>
//                     {apps.map((app) => (
//                        <li key={app._id}>
                         
//                          <p className='jobDetails'><strong>Applicant Name:</strong> {app.name}</p>
//                          <p className='jobDetails'><strong>Standard:</strong> {app.std}</p>
//                          <p className='jobDetails'><strong>School Name:</strong> {app.school}</p>
//                          <p className='jobDetails'><strong>Contact Number:</strong> {app.contact}</p>
//                        </li>
//                       ))}
//                    </ul>
                  
//                 </div>
            
//               </div>
//             ))}
//      </div>
//   </Box>
//     );
// }



// export default Applications;
